module.exports = __webpack_public_path__ + "img/post3.35aaf969.png";